interface MonthRow {
  month: string;       // "YYYY-MM"
  new: number;
  deleted: number;
}

function shortMonth(ym: string): string {
  const [, m] = ym.split("-");
  if (!m) return ym;
  return new Date(2000, Number(m) - 1, 1).toLocaleString(undefined, { month: "short" });
}

export function MonthlyChart({ data }: { data: MonthRow[] }) {
  const max = Math.max(1, ...data.flatMap((d) => [d.new, d.deleted]));

  return (
    <div>
      <div className="flex items-center gap-4 text-[12px] text-fh-gray mb-3">
        <span className="inline-flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-sm bg-fh-green" />
          New
        </span>
        <span className="inline-flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-sm bg-red-400" />
          Deleted
        </span>
      </div>

      <div className="flex items-end gap-3 h-[140px]">
        {data.map((d) => {
          const newH = (d.new / max) * 100;
          const delH = (d.deleted / max) * 100;
          return (
            <div key={d.month} className="flex-1 flex flex-col items-center gap-1.5 min-w-0">
              <div className="flex items-end gap-1 h-[112px] w-full justify-center">
                <div className="flex flex-col items-center w-full">
                  <div className="text-[10px] font-semibold text-fh-green-dark mb-0.5">
                    {d.new || ""}
                  </div>
                  <div
                    className="w-full max-w-[22px] bg-fh-green rounded-t-sm"
                    style={{ height: `${newH}px` }}
                    title={`${d.new} new`}
                  />
                </div>
                <div className="flex flex-col items-center w-full">
                  <div className="text-[10px] font-semibold text-red-700 mb-0.5">
                    {d.deleted || ""}
                  </div>
                  <div
                    className="w-full max-w-[22px] bg-red-400 rounded-t-sm"
                    style={{ height: `${delH}px` }}
                    title={`${d.deleted} deleted`}
                  />
                </div>
              </div>
              <div className="text-[11px] text-fh-gray">{shortMonth(d.month)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
